<template>
  <BaseFormCard
    :heading="submitName + ' Service'"
    :submit-title="submitName"
    @submit="submit"
  >
    <BaseSelect
      v-model="service.service_group_id"
      :options="serviceGroups"
      name="service_group"
      title="Service Group"
      placeholder="Select Group"
      bind-by="id"
      label="name"
    />
    <BaseInput
      v-model="service.name"
      title="Name"
      name="name"
      type="text"
      placeholder="Name"
      required
      trim
    />
    <BaseInput
      v-model="service.descr"
      title="Description"
      name="descr"
      type="text"
      placeholder="Description"
      required
      trim
    />
    <BaseInputPrice
      v-model.number="service.price"
      title="Price"
      name="price"
    />
    <BaseInputNumber
      v-model.number="service.slo"
      title="SLO (days)"
      name="slo"
    />
    <BaseInputNumber
      v-model.number="service.max"
      title="Maximum Count"
      name="max"
    />
    <BaseInput
      v-model="service.colour"
      title="Colour"
      name="colour"
      pattern="^#([0-9a-fA-F]{1,2}){3,4}$"
      trim
    />
    <BaseTextarea
      v-model="service.warning"
      title="Warning"
      name="warning"
      trim
    />
    <BaseTextarea
      v-model="service.info"
      title="Info"
      name="info"
      trim
    />
    <BaseSelect
      v-model="service.service_icon_id"
      :options="serviceIcons"
      title="Icon"
      name="service_icon"
      bind-by="id"
      label="filename"
    />
    <BaseSelect
      v-model="service.required_attachments"
      :options="attachmentTypes"
      title="Required Attachments"
      name="attachments"
      track-by="id"
      label="name"
      multiple
    />
    <BaseSelect
      v-model="service.team_id"
      :options="teams"
      title="Team"
      name="team"
      bind-by="id"
      label="name"
    />
    <BaseInputCheckbox
      v-model="service.is_default"
      title="Is Default"
      name="is_default"
    />
    <FieldError v-model="error" />
  </BaseFormCard>
</template>

<script>
import FieldError from '@/components/FieldError'
import groupAPI from '@/api/group'
import teamAPI from '@/api/team'

export default {
  components: {
    FieldError,
  },
  props: {
    groupId: {
      type: [String, Number],
      required: true,
    },
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data () {
    return {
      service: {
        service_group_id: null,
        service_icon_id: null,
        team_id: null,
        name: '',
        descr: '',
        warning: null,
        info: null,
        price: null,
        slo: null,
        max: null,
        required_attachments: [],
        colour: null,
        is_default: false,
      },
      serviceIcons: [],
      serviceGroups: [],
      attachmentTypes: [],
      teams: [],
      error: '',
    }
  },
  computed: {
    submitName () {
      if (!this.id) {
        return 'Create'
      }
      return 'Update'
    },
  },
  beforeMount () {
    this.getData()
  },
  methods: {
    getData () {
      const promises = [
        groupAPI.getAttachmentTypes(this.groupId),
        groupAPI.getServiceGroups(this.groupId),
        groupAPI.getServiceIcons(this.groupId),
        teamAPI.getTeams(),
      ]
      if (this.id) {
        promises.push(groupAPI.getService(this.groupId, this.id))
      }
      Promise.all(promises).then(([attachmentTypes, serviceGroups, serviceIcons, teams, service]) => {
        this.attachmentTypes = attachmentTypes.data
        this.serviceIcons = serviceIcons.data
        this.serviceGroups = serviceGroups.data
        this.teams = teams.data
        if (this.id) {
          this.service = service.data
        }
      }).catch(error => {
        this.error = error.message
      })
    },
    create () {
      groupAPI.createService(this.groupId, this.service).then(resp => {
        this.$router.go(-1)
      }).catch(error => {
        this.error = error.message
      })
    },
    update () {
      groupAPI.updateService(this.groupId, this.service).then(resp => {
        this.$router.go(-1)
      }).catch(error => {
        this.error = error.message
      })
    },
    submit () {
      if (this.id) {
        this.update()
      } else {
        this.create()
      }
    },
  },
}
</script>
